import { render, staticRenderFns } from "./BaSettings.vue?vue&type=template&id=48224c3f&"
import script from "./BaSettings.vue?vue&type=script&lang=js&"
export * from "./BaSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports